// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sp6VZgMI7LSvbYsV75NJ{border-color:#671e69;background:#671e69}`, "",{"version":3,"sources":["webpack://./../../../tools/nodeParticleEditor/dist/graphSystem/display/conditionDisplayManager.module.scss"],"names":[],"mappings":"AAAA,sBACI,oBAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
var _1 = `Sp6VZgMI7LSvbYsV75NJ`;
export { _1 as "condition-display" };
export default ___CSS_LOADER_EXPORT___;
